export default "__VITE_ASSET__CHgv1BjG__"